import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { onMounted } from "vue";
import { useStore } from "vuex";
import { is_ios_h5 } from "@/utils/devices";
import { getFingerprint } from "@/utils/make";
const __default__ = {
  name: 'App'
};
export default /*@__PURE__*/Object.assign(__default__, {
  setup(__props) {
    const store = useStore();
    onMounted(async () => {
      window.ulGetParamsCallBack = (key, value) => {
        if (is_ios_h5()) {
          if (key == 'is_auto_login') {
            store.commit('setIsAutoLogin', Boolean(value));
          } else if (key == 'small_id') {
            store.commit('setSmallId', value);
          } else if (key == 'pay_order_number') {
            store.commit('setPayOrderNumber', value);
          } else {
            store.commit('setItemState', {
              key,
              value
            });
          }
        }
      };
      await getFingerprint();
    });
    return (_ctx, _cache) => {
      const _component_router_view = _resolveComponent("router-view");
      return _openBlock(), _createBlock(_component_router_view);
    };
  }
});